import type { TSubscription } from "../types"

export const getStoragePercent = (used: number, total: number): number =>
  total === 0 ? 0 : Math.min(Math.round((used / total) * 100), 100)

export const getLicensesAvailable = (consumed: number, total: number): number =>
  Math.max(total - consumed, 0)

export const isStorageWarning = (used: number, total: number): boolean =>
  getStoragePercent(used, total) >= 80

export const isStorageCritical = (used: number, total: number): boolean =>
  getStoragePercent(used, total) >= 90

export const isStorageFull = (used: number, total: number): boolean =>
  getStoragePercent(used, total) >= 100

export const isLicensesWarning = (consumed: number, total: number): boolean =>
  getLicensesAvailable(consumed, total) <= 5

export const isLicensesCritical = (consumed: number, total: number): boolean =>
  getLicensesAvailable(consumed, total) <= 2

export const isLicensesExhausted = (consumed: number, total: number): boolean =>
  getLicensesAvailable(consumed, total) === 0

export const isDaysWarning = (days: number): boolean => days <= 30

export const isDaysCritical = (days: number): boolean => days <= 14

export const isExpired = (days: number): boolean => days <= 0

export const isSubscriptionBlocked = (sub: TSubscription): boolean =>
  sub.status === "expired" ||
  sub.status === "grace_period" ||
  sub.status === "suspended" ||
  isLicensesExhausted(sub.licenses_consumed, sub.licenses_total)


export const formatBytes = (bytes: number): string => {
  if (bytes === 0) return "0 B"
  const k = 1024
  const sizes = ["B", "KB", "MB", "GB", "TB"]
  const i = Math.floor(Math.log(bytes) / Math.log(k))
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(1))} ${sizes[i]}`
}
